import React from 'react';
import { useSelector } from 'react-redux';
import Button from 'components/Button';
import Typography from 'newComponents/Typography';
import PropTypes from 'prop-types';
import { parseDateForPBI } from '../../../utils/date';

const PlayButton = ({ buttonConfig, onClick }) => {
  const asset = useSelector(state => state.asset);
  const translations = useSelector(state => state.translations);
  if (!buttonConfig || buttonConfig.visible !== '1') return null;
  
  const { startdate } = buttonConfig;
  if (startdate && parseDateForPBI(startdate) > Date.now()) {
    return (
      <Button buttonType="action" onClick={() => onClick('date_button_play')}>
        <div className="ActionButton__content">
          <div className="ActionButton__content__image">
            <img src={asset.vcard_access_option_icon_play} alt="play" />
          </div>
          <Typography apaKey="date_button" />
        </div>
      </Button>
    );
  }

  return (
    <Button className="play-button" buttonType="action" onClick={() => onClick('play')}>
      <div className="ActionButton__content play-button">
        <div className="ActionButton__content__image">
          <img src={asset.vcard_access_option_icon_play} alt="play" />
        </div>
        <p className="ActionButton__content__text">
          {translations.vcard_access_option_button_play}
        </p>
      </div>
    </Button>
  );
};

PlayButton.propTypes = {
  buttonConfig: PropTypes.shape({
    visible: PropTypes.string,
    startdate: PropTypes.string,
  }),
  onClick: PropTypes.func,
};

PlayButton.defaultProps = {
  buttonConfig: {},
  onClick: () => 1,
};

export default PlayButton;
